import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dataList } from '../../models/search-branches-model';

type State = {
  districtList: dataList;
  error: string;
};

const initialState: State = {
  districtList: {
    all: [],
    cj: [],
    td: [],
  },
  error: '',
};

const districtListSlice = createSlice({
  name: 'SubDistrictList',
  initialState,
  reducers: {
    clearDistrictList: (state) => {
      state.districtList = initialState.districtList;
    },
    saveDistrictList: (state, action: PayloadAction<any>) => {
      state.districtList = action.payload;
    },
  },
});

export const { clearDistrictList, saveDistrictList } = districtListSlice.actions;
export default districtListSlice.reducer;
